import { connect } from 'react-redux';
import { addToken } from '../actions/addToken'
import { cacheHostedUiToken } from '../utils/hostedUiToken';
import { useHistory } from "react-router-dom";
import React from 'react'


const HostedUiRedirect = ({dispatch}) => {
    const history = useHistory();

    try {
        const response = new URLSearchParams(window.location.hash.replace(/^#/, ''));
        let jwt = response.get("id_token");
        console.log(jwt);
        if (jwt) {
            cacheHostedUiToken(jwt, response.get("expires_in"));
        }
        dispatch(addToken(jwt));

        history.push("/dashboard");
    } catch (error) {
        console.log(error)
    }
    return (
        <div>
            Loading...
        </div>
    )
}

export default connect()(HostedUiRedirect)
